module.exports = __webpack_public_path__ + "vue/img/default_thumbnail.5aa465f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/default_thumbnail.png
// module id = kSmf
// module chunks = 1